/**
 * Formatação canônica de data/hora do módulo Produção v2 (brief F.2):
 * SEMPRE `dd/mmm hh:mm` (com o dia — nunca `hh:mm` solto). Ex.: "14/jul 09:32".
 *
 * Cuidado com strings date-only ("2026-07-14"): `new Date("2026-07-14")`
 * interpreta como MEIA-NOITE UTC, que no fuso do Brasil vira o dia
 * ANTERIOR às 21h. Por isso o parser trata date-only como data LOCAL.
 */

const MESES_CURTOS = [
  "jan", "fev", "mar", "abr", "mai", "jun",
  "jul", "ago", "set", "out", "nov", "dez",
];

const RE_DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

function parseData(valor) {
  if (valor == null || valor === "") return null;
  if (valor instanceof Date) {
    return Number.isNaN(valor.getTime()) ? null : valor;
  }
  const s = String(valor);
  const dateOnly = RE_DATE_ONLY.exec(s);
  if (dateOnly) {
    // Date-only: constrói em horário LOCAL (evita o shift de fuso do UTC).
    return new Date(
      Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]),
    );
  }
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

function dois(n) {
  return String(n).padStart(2, "0");
}

/** "2026-07-14" | ISO datetime | Date -> "14/jul". Vazio/inválido -> fallback. */
export function formatarDataCurta(valor, fallback = "–") {
  const d = parseData(valor);
  if (!d) return fallback;
  return `${dois(d.getDate())}/${MESES_CURTOS[d.getMonth()]}`;
}

/** ISO datetime | Date -> "14/jul 09:32". Vazio/inválido -> fallback. */
export function formatarDataHoraCurta(valor, fallback = "–") {
  const d = parseData(valor);
  if (!d) return fallback;
  return (
    `${dois(d.getDate())}/${MESES_CURTOS[d.getMonth()]} ` +
    `${dois(d.getHours())}:${dois(d.getMinutes())}`
  );
}

/**
 * Minutos totais -> "80h 20min" | "8h" | "45min" (SEM colapsar em dias —
 * usado nos KPIs agregados do P4, onde "80h 20min" comunica melhor que
 * "+3d"). 0/nulo/inválido -> fallback.
 */
export function formatarHorasMinutos(totalMinutos, fallback = "–") {
  const min = Math.round(Number(totalMinutos) || 0);
  if (min <= 0) return fallback;
  const h = Math.floor(min / 60);
  const m = min % 60;
  if (h <= 0) return `${m}min`;
  return m > 0 ? `${h}h ${m}min` : `${h}h`;
}

/**
 * Minutos acumulados de atraso -> forma curta legível:
 *   0/nulo -> "–" · 45 -> "45m" · 200 -> "3h 20m" · 180 -> "3h" ·
 *   >= 1 dia -> "+2d".
 */
export function formatarMinutosAtraso(totalMinutos, fallback = "–") {
  const min = Math.trunc(Number(totalMinutos) || 0);
  if (min <= 0) return fallback;
  if (min >= 1440) return `+${Math.floor(min / 1440)}d`;
  const h = Math.floor(min / 60);
  const m = min % 60;
  if (h <= 0) return `${m}m`;
  return m > 0 ? `${h}h ${m}m` : `${h}h`;
}
